import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getImageInfo, getVideoInfo } from '../../../../_utils/material';
export var transVideoUploadValue = function transVideoUploadValue(source) {
  var mpSrcMd5 = source.media_md5,
    videoFileSize = source.media_size,
    width = source.media_width,
    height = source.media_height,
    videoDuration = source.media_duration,
    mpPosterMd5 = source.image_md5,
    materialId = source.transcode_media_id,
    vid = source.original_media_vid,
    originalMaterialId = source.original_media_id,
    poster = source.adq_image_url,
    mpSrc = source.media_url,
    mpPoster = source.image_url;
  return {
    poster: poster,
    vid: vid,
    src: mpSrc,
    width: width,
    height: height,
    materialId: materialId,
    originalMaterialId: originalMaterialId,
    mpPoster: mpPoster,
    mpPosterMd5: mpPosterMd5,
    mpSrc: mpSrc,
    mpSrcMd5: mpSrcMd5,
    videoFileSize: videoFileSize,
    videoDuration: Math.round(videoDuration / 1000),
    videoBitRate: videoDuration * 8
  };
};
export var transImageUploadValue = function transImageUploadValue(val) {
  var materialId = val.image_id,
    imageUrl = val.base_image_url,
    imageMPUrl = val.mp_image_url,
    imageWidth = val.image_width,
    imageHeight = val.image_height,
    imageSize = val.image_file_size,
    imageMd5 = val.image_signature,
    description = val.description,
    fileType = val.image_type;
  return {
    materialId: materialId,
    imageMPUrl: imageMPUrl,
    imageMd5: imageMd5,
    imageSize: imageSize,
    imageUrl: imageUrl,
    imageWidth: imageWidth,
    imageHeight: imageHeight,
    description: description,
    fileType: fileType
  };
};
export var fileMultipleSelect = function fileMultipleSelect(option) {
  return fileSelect(option);
};
export var fileSingleSelect = function fileSingleSelect(option) {
  return fileSelect(option).then(function (fileList) {
    return Promise.resolve(fileList[0]);
  });
};
var fileSelect = function fileSelect(option) {
  var accept = option.accept,
    _option$multiple = option.multiple,
    multiple = _option$multiple === void 0 ? false : _option$multiple;
  var elInput = document.createElement('input');
  elInput.type = 'file';
  elInput.multiple = multiple;
  elInput.accept = accept;
  return new Promise(function (r, j) {
    elInput.onchange = function (evt) {
      var _a;
      var fileList = (_a = evt.target) === null || _a === void 0 ? void 0 : _a.files;
      if (!fileList || fileList.length === 0) {
        var errMsg = '当前选择文件为空，请检查';
        console.error(errMsg);
        return j(errMsg);
      }
      r(fileList);
    };
    elInput.click();
  });
};
export var selectVideoFile = function selectVideoFile(option) {
  return fileSingleSelect(option).then(function (file) {
    return getVideoInfo({
      file: file
    }).then(function (info) {
      return _objectSpread(_objectSpread({}, info), {}, {
        file: file
      });
    });
  });
};
export var selectImageFile = function selectImageFile(option) {
  return fileSingleSelect(option).then(function (file) {
    return getImageInfo({
      file: file
    }).then(function (info) {
      return _objectSpread(_objectSpread({}, info), {}, {
        file: file
      });
    });
  });
};
export function selectedMultipleImageFile(option) {
  return fileMultipleSelect(option).then(function (fileList) {
    var promiseArray = [];
    for (var i = 0; i < fileList.length; i++) {
      promiseArray.push(getImageInfo({
        file: fileList[i]
      }));
    }
    return Promise.all(promiseArray).then(function (res) {
      return res.map(function (info, index) {
        return _objectSpread(_objectSpread({}, info), {}, {
          file: fileList[index]
        });
      });
    });
  });
}